import { render, staticRenderFns } from "./MatchDetail.vue?vue&type=template&id=6e81fdc8&"
import script from "./MatchDetail.vue?vue&type=script&lang=js&"
export * from "./MatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./MatchDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports